export default "__VITE_ASSET__m7tPu4VT__"